/**
 * Theme — Quantity Selector Web Component
 *
 * Handles +/- button clicks for the quantity stepper.
 * Loaded for ALL products (with or without variants) so the stepper
 * always works even when variant-picker.js is not present.
 */

if (!customElements.get('quantity-selector')) {
  customElements.define(
    'quantity-selector',
    class QuantitySelector extends HTMLElement {
      connectedCallback() {
        this.addEventListener('click', this.onButtonClick.bind(this));
      }

      onButtonClick(event) {
        const btn = event.target.closest(
          '[data-action="decrease"], [data-action="increase"]'
        );
        if (!btn) return;

        const wrap = btn.closest('.quantity-selector__wrap');
        if (!wrap) return;

        const input = wrap.querySelector('.quantity-selector__input');
        if (!input) return;

        const currentVal = parseInt(input.value, 10) || 1;
        const min = parseInt(input.min, 10) || 1;
        const max = input.max ? parseInt(input.max, 10) : Infinity;

        if (btn.dataset.action === 'decrease') {
          input.value = Math.max(min, currentVal - 1);
        } else {
          input.value = Number.isFinite(max)
            ? Math.min(max, currentVal + 1)
            : currentVal + 1;
        }

        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }
  );
}
